import { Component } from '@angular/core';

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss'],
    standalone: false
})
export class AdministrationComponent {}
